/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
var a = new RegExp('/' + window.location.host + '/');
$('a').each(function() {
   if(!a.test(this.href)) {
       $(this).click(function(event) {
           event.preventDefault();
           event.stopPropagation();
           window.open(this.href, '_blank');
       });
   }
});

$(window).on('resize',function(e) {
  setTimeout(function(e) {
    var height = $('.media-gallery .slick-slide.slick-active .media-gallery__item img').height();
    $('.media-gallery .slick-list.draggable').css('height',height+'px')
  },500) 
})